import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from "motion/react";

const CTA = () => {
    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    }

    const listItemVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: (index) => ({
            opacity: 1,
            x: 0,
            transition: { duration: 0.4, delay: index * 0.1 + 0.3 }
        })
    }

    const benefits = [
        "No hard sales",
        "Actionable next steps",
        "100% free"
    ]

    return (
        <section className="section-lg pt-0 overflow-hidden" id="contact-growth">
            <Container>
                <motion.div
                    variants={cardVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    whileHover={{ scale: 1.01, transition: { duration: 0.3 } }}
                >
                    <Card className="border-0 shadow-sm rounded-4 bg-light">
                        <Card.Body className="p-4 p-lg-5">
                            <Row className="align-items-center g-4">
                                <Col lg={8} xs={12}>
                                    <motion.h2 className="text-primary mb-2"
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: 0.2, duration: 0.5 }}
                                    >
                                        Ready to build your Growth Strategy?
                                    </motion.h2>
                                    <motion.p className="text-secondary mb-3"
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: 0.3, duration: 0.5 }}
                                    >
                                        Book 30 minutes with our team and get a prioritized action plan tailored to your goals.
                                    </motion.p>
                                    <ul className="list-unstyled d-flex flex-wrap gap-3 mb-0">
                                        {benefits.map((benefit, index) => (
                                            <motion.li key={index} className="d-flex align-items-center text-secondary"
                                                variants={listItemVariants}
                                                initial="hidden"
                                                whileInView="visible"
                                                viewport={{ once: true }}
                                                custom={index}
                                            >
                                                <i className="ri-checkbox-circle-line text-success me-2"></i> {benefit}
                                            </motion.li>
                                        ))}
                                    </ul>
                                </Col>
                                <Col lg={4} xs={12} className="text-lg-end text-start">
                                    <div className="d-grid d-lg-inline-flex gap-2">
                                        <motion.a href="/index.html#contactus" className="btn btn-gradient"
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                        >
                                            Talk to an Expert
                                        </motion.a>
                                        <motion.a href="/index.html#pricing" className="btn btn-primary"
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                        >
                                            See Plans
                                        </motion.a>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </motion.div>
            </Container>
        </section>
    )
}

export default CTA;